<template>
    <el-container>
        <el-header style="height:100%">
            <el-form :inline="true" :model="leavelBill" ref="leavelBill" class="demo-form-inline" :rules="rules" label-width="90px">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item :label="$t('pgCommon.WORK_FLOW_CAPTION')" prop="message1">
                            <td-select :options="leaveBillTypeList" v-model="leavelBill.proDefKey" keys="templateKey" text="templateName" :disabled="isEdit" ref="message1"></td-select>
                        </el-form-item>
                        <el-form-item :label="$t('pgCommon.DISPOSE_PERSON')" prop="userId">
                            <td-input v-model="leavelBill.userId" maxlength="20" :disabled="true"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('pgCommon.APPLICANT')" prop="userId">
                            <td-input v-model="leavelBill.userId" :disabled="true" maxlength="20"></td-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('pgCommon.START_TIME')" prop="startTime">
                            <td-date-time v-model="leavelBill.startTime" :disabled="isEdit"></td-date-time>
                        </el-form-item>
                        <el-form-item :label="$t('pgCommon.END_TIME')" prop="endTime">
                            <td-date-time v-model="leavelBill.endTime" :disabled="isEdit"></td-date-time>
                        </el-form-item>
                        <el-form-item :label="$t('pgCommon.USE_TIME')" prop="days">
                            <td-input-number v-model="leavelBill.days" :min="0" :max="999"></td-input-number>
                        </el-form-item>
                        <!-- <el-form-item :label="$t('pgCommon.USE_TIME')" prop="days">
                            <td-input v-model="leavelBill.days" maxlength="3" :disabled="isEdit"></td-input>
                        </el-form-item> -->
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('pgCommon.APPLICATE_DEP')" prop="userDep">
                            <td-input v-model="leavelBill.userDep" :disabled="isEdit" maxlength="20"></td-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('pgCommon.APPLICANT_REASON')" prop="leaveReason">
                            <td-input type="textarea" v-model="leavelBill.leaveReason" width="758" :rows="4" :disabled="isEdit" maxlength="200"></td-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="width:830px;text-align:center">
                        <el-form-item>
                            <td-button type="primary" v-show="btnSubmitShow" :loading="loading" @click="btnSubmit()">{{ $t('pgCommon.SUBMIT') }}</td-button>
                            <td-button type="button" v-show="rejectShow" :loading="loading" @click="reject">{{ $t('pgCommon.REMOVE') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
    </el-container>
</template>
<script>
import Api from './assets/api.js';
export default {
    // props: ['title', 'dialogLeaveBillVisible', 'isAddData', 'editItem'],
    mounted() {
        this.initSelect();
        // this.startProcess();
    },
    // 定义变量
    data() {
        return {
            //表单信息
            leavelBill: {
                userId: sessionStorage.getItem('userId'),
                userName: sessionStorage.getItem('userName'),
                startTime: '',
                endTime: '',
                applyUserId: sessionStorage.getItem('userId'),
                proDefKey: '',
                proInsId: '',
                actId: '',
                taskId: '',
                taskName: '',
                days: 0
            },
            isShow: false,
            btnShow: true,
            btnSubmitShow: true,
            rejectShow: false,
            currPerson: sessionStorage.getItem('userId'),
            currPerName: sessionStorage.getItem('username'),
            taskUser: sessionStorage.getItem('userId'),
            loading: false, // 按钮是否为加载状态
            // 请假类型
            leaveBillTypeList: [],
            // 人员列表
            userIdList: [],
            isEdit: false,
            rules: {
                // userId: [
                //     { required: true, message: this.$t('pgError.ERROR_APPLICANT_CAPTION_NULL'), trigger: 'blur' },
                //     {
                //         pattern: this.$regex.USERCAPTION_RULE,
                //         message: this.$t('pgError.ERROR_APPLICANT_CAPTION_ILLEGAL')
                //     }
                // ],
                // // message1: [
                // //     { message: this.$t('pgError.ERROR_APPLICANT_DEP_CAPTION_NULL'), trigger: 'blur' },
                // //     {
                // //         pattern: this.$regex.CAPTION_RULE,
                // //         message: this.$t('pgError.ERROR_APPLICANT_DEP_CAPTION_ILLEGAL')
                // //     }
                // // ],
                // // date1: [
                // //     { message: this.$t('pgError.ERROR_USER_NO_NULL'), trigger: 'blur' },
                // //     {
                // //         pattern: this.$regex.NUM,
                // //         message: this.$t('pgError.ERROR_USER_NO_ILLEGAL')
                // //     }
                // // ],
                // // date2: [
                // //     { message: this.$t('pgError.ERROR_DAYS_NULL'), trigger: 'blur' },
                // //     {
                // //         pattern: this.$regex.NUM,
                // //         message: this.$t('pgError.ERROR_DAYS_ILLEGAL')
                // //     }
                // // ],
                // message1: [{ required: true, message: this.$t('pgError.ERROR_REASON_NULL'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        btnSubmit() {
            this.loading = true;
            if (!this.leavelBill.proDefKey || '' == this.leavelBill.proDefKey) {
                this.$message({ type: 'warning', showClose: true, message: this.$t('请选择发起的流程！') });
                this.loading = false;
                return;
            }
            // 有效性验证
            let param = {
                proDefKey: this.leavelBill.proDefKey,
                userName: sessionStorage.getItem('userName'),
                userDep: this.leavelBill.userDep,
                userId: sessionStorage.getItem('userId'),
                leaveBillType: this.leavelBill.leaveBillType,
                startTime: this.leavelBill.startTime,
                endTime: this.leavelBill.endTime,
                days: this.leavelBill.days,
                leaveReason: this.leavelBill.leaveReason,
                taskId: this.leavelBill.taskId,
                proInsId: this.leavelBill.proInsId
            };
            Api.submitLeaveBill(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('/WorkFlowDemoController/submitLeaveBill', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.SUBMIT_SUCCESS') });
                this.leavelBill.proInsId = response.data.content.sWorkflowId;
                this.loading = false;
                this.isEdit = true;
                this.rejectShow = true;
                this.btnSubmitShow = false;
            });
        },
        //撤回任务
        reject() {
            let param = this.leavelBill;
            this.loading = true;
            this.operEdit = true;
            Api.deleteProIns(JSON.stringify(param), response => {
                this.operEdit = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.REMOVE_SUCCESS') });
                this.loading = false;
                this.isEdit = false;
                this.btnSubmitShow = true;
                this.rejectShow = false;
                // this.dialogLeaveBillClose();
            });
        },
        // 初始化类型下拉框
        initSelect() {
            // let groupParam = {
            //     id: 'group1',
            //     name: '',
            //     type: ''
            // };
            let param = {
                isNeedPage: false
            };
            // Api.queryGroupInfoList(JSON.stringify(groupParam), response => {
            //     this.userIdList = response.data.content;
            // });
            Api.queryTemplate(JSON.stringify(param), response => {
                this.leaveBillTypeList = response.data.content;
            });
        }
        // btnCancel() {
        //     this.$emit('dialogLeaveBillClose');
        // },
        // // 关闭窗口之前需要调用的方法
        // dialogLeaveBillClose() {
        //     this.$emit('dialogLeaveBillClose');
        //     this.dialogLeaveBillVisible = false;
        // }
    }
};
</script>
